import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

const TOKEN_NAME = "ies-access-token";
const AUTHENTICATE_EXTERNAL_USER_URL =
  "/individualexamscheduler/services/externaluser/login";
const AUTHENTICATE_INTERNAL_USER_URL =
  "/individualexamscheduler/services/internaluser/login";
function getToken() {
  return Cookies.get(TOKEN_NAME);
}

function fetchToken(url: string) {
  if (getToken() === undefined) {
    window.location.replace(url);
  }
}

function clearToken() {
  Cookies.remove(TOKEN_NAME, {
    domain: window.location.hostname,
    path: import.meta.env.BASE_URL,
  });
}

const slice = createSlice({
  name: "token",
  initialState: () => getToken() ?? null,
  reducers: {
    authenticateInternalUser: () => {
      fetchToken(AUTHENTICATE_INTERNAL_USER_URL);
    },
    authenticateExternalUser: () => {
      fetchToken(AUTHENTICATE_EXTERNAL_USER_URL);
    },
    logout: (state: string | null) => {
      clearToken();
      state = getToken() ?? null;
      return state;
    },
  },
});

export const { authenticateExternalUser, authenticateInternalUser, logout } =
  slice.actions;
export default slice.reducer;
